<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop" style="max-width: 800px">
        <div class="pop_tit _flex">
            <p>{{ state.item.idx ? "질문 수정" : "질문 추가" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form custom_scroll">
            <div class="select_tab_box_wrap" style="margin-bottom: 10px">
                <div class="select_tab_box _230" v-click-outside="clickoutside">
                    <div class="selected_tab" :class="{ active: state.isShowType }" @click="state.isShowType = !state.isShowType">
                        <span>{{ state.strType }}</span>
                    </div>

                    <div class="tab_option" v-show="state.isShowType" :class="{ active: state.isShowType }">
                        <button
                            type="button"
                            @click="
                                state.type = 1;
                                state.strType = '객관식';
                                state.isShowType = false;
                            "
                        >
                            객관식
                        </button>
                        <button
                            type="button"
                            @click="
                                state.type = 2;
                                state.strType = '객관식(복수형)';
                                state.isShowType = false;
                            "
                        >
                            객관식(복수형)
                        </button>
                        <button
                            type="button"
                            @click="
                                state.type = 3;
                                state.strType = '주관식';
                                state.isShowType = false;
                            "
                        >
                            주관식
                        </button>
                    </div>
                </div>
                <label for="isPrivacy" v-if="state.type === 3">
                    <input id="isPrivacy" type="checkbox" placeholder="민감정보" v-model="state.isPrivacy" :true-value="1" :false-value="0" />
                    <p>민감정보</p>
                </label>
            </div>

            <div style="margin-bottom: 10px">
                <input type="text" placeholder="질문을 입력해주세요" v-model="state.item.title" />
            </div>

            <div v-if="state.type !== 3">
                <div class="common_table custom_scroll _flex" style="height: auto; max-height: calc(100vh - 500px)">
                    <table>
                        <colgroup>
                            <col style="width: 80px" />
                            <col />
                            <col style="width: 50px" />
                        </colgroup>

                        <tbody>
                            <template v-if="state.list.length > 0">
                                <tr v-for="(item, idx) in state.list" :key="idx">
                                    <td class="cnt">
                                        <button type="button" class="move_up _sub" @click="move(idx, true)">
                                            <img src="img/up_icon.png" alt="" />
                                        </button>
                                        <button type="button" class="move_down _sub" @click="move(idx, false)">
                                            <img src="img/down_icon.png" alt="" />
                                        </button>
                                    </td>
                                    <td style="text-align: left">
                                        <input type="text" placeholder="질문을 입력해주세요" v-model="item.title" />
                                    </td>
                                    <td class="cnt p_5" style="text-align: right; padding: 0">
                                        <button type="button" class="table_btn _gray" style="margin-right: 0" @click="isDelete(item.idx)">
                                            삭제
                                        </button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="6">
                                    <div class="tb_subject" style="text-align: center; width: 100%">등록한 신청 양식이 없습니다.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="_flex _center btn_wrap">
                    <button type="button" class="blue_btn" style="padding: 0 10px; width: 100%" @click="addCase">선택지 추가+</button>
                </div>
            </div>
        </div>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" @click="save">저장</button>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, ModalDefault } from "@/BaseComponent";
    import { isReactive } from "vue";

    export default {
        props: {
            item: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                item: {} as any,
                list: [] as Array<any>,

                idxForRemove: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowType: false as boolean,
                type: 1 as number,
                strType: "객관식" as string,
                isPrivacy: 0 as number,
            });

            onMounted(() => {
                state.item = props.item;
                if (props.item && props.item.isPrivacy) state.isPrivacy = props.item.isPrivacy;

                if (state.item.type) {
                    state.type = state.item.type;
                    switch (state.type) {
                        case 1:
                            {
                                state.strType = "객관식";
                            }
                            break;

                        case 2:
                            {
                                state.strType = "객관식(복수형)";
                            }
                            break;

                        case 3:
                            {
                                state.strType = "주관식";
                            }
                            break;
                    }
                }

                if (state.type !== 3) {
                    list();
                }
            });

            watch(props, () => {
                state.item = props.item;
                if (props.item && props.item.isPrivacy) state.isPrivacy = props.item.isPrivacy;

                if (state.item.type) {
                    state.type = state.item.type;
                    switch (state.type) {
                        case 1:
                            {
                                state.strType = "객관식";
                            }
                            break;

                        case 2:
                            {
                                state.strType = "객관식(복수형)";
                            }
                            break;

                        case 3:
                            {
                                state.strType = "주관식";
                            }
                            break;
                    }
                }
                if (state.type !== 3) {
                    list();
                }
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const list = async () => {
                if (!state.item.idx) return;
                const res = await apiService.board.listForCase(state.item.idx);
                if (res.returnCode === 0) {
                    state.list = res.data;
                }
            };

            const changeOrder = async (idx: number, arrow: number) => {
                const res = await apiService.board.isOrderForm(idx, arrow);
                if (res.returnCode === 0) {
                    // getList();
                }
            };

            const isDelete = (idx: number) => {
                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;

                state.idxForRemove = idx;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove(state.idxForRemove);
                    state.isShowModal = false;
                } else if (param.action === "callback") {
                    emit("callback");
                }
            };

            const remove = async (idx: number) => {
                const index = state.list.findIndex((item: any) => item.idx === idx);
                if (index !== -1) {
                    state.list.splice(index, idx);
                }
            };

            const addCase = () => {
                state.list.push({ idx: state.list.length + 1, title: "", orderNo: 0, isChecked: null });
            };

            const save = () => {
                if (state.item.idx > 0) {
                    modify();
                } else {
                    add();
                }
            };

            const add = async () => {
                if (valueCheck()) {
                    const param: types.ReqBoardApplyForm = {
                        idx: state.item.boIdx,
                        type: state.type,
                        title: state.item.title,
                        caseList: state.list.map((item: any) => item.title),
                        isPrivacy: state.isPrivacy,
                    };
                    const res = await apiService.board.addForm(param);

                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "알림";
                        state.modalContent = "등록되었습니다.";
                        state.isShowModal = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const modify = async () => {
                if (valueCheck()) {
                    const param: types.ReqBoardApplyForm = {
                        idx: state.item.idx,
                        type: state.type,
                        title: state.item.title,
                        caseList: state.list.map((item: any) => item.title),
                        isPrivacy: state.isPrivacy,
                    };
                    const res = await apiService.board.modifyForm(param);

                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "알림";
                        state.modalContent = "수정이 완료되었습니다.";
                        state.isShowModal = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const valueCheck = () => {
                let msg = "";
                if (!state.item.title) msg = "질문을 입력해주세요.";
                else if (state.type !== 3) {
                    if (state.list.length === 0) msg = "보기를 추가해주세요.";
                    else if (state.list.some((item) => item.title == "")) msg = "보기 내용을 입력해주세요.";
                }

                if (msg) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = msg;
                    state.isShowModal = true;
                    return false;
                } else {
                    return true;
                }
            };

            const move = (index: number, arrow: boolean) => {
                if (arrow) {
                    if (index === 0) return;
                    [state.list[index - 1], state.list[index]] = [state.list[index], state.list[index - 1]];
                } else {
                    if (index === state.list.length - 1) return;
                    [state.list[index + 1], state.list[index]] = [state.list[index], state.list[index + 1]];
                }
            };

            const clickoutside = () => {
                state.isShowType = false;
            };

            return {
                state,
                props,
                CommonUtils,
                isDelete,
                closeModal,
                changeOrder,
                callBackModal,
                addCase,
                move,
                save,
                clickoutside,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk .date_wrap {
        margin: 0;
    }
    .common_table td {
        border: 0;
        padding: 10px;
    }

    .common_table td button {
        margin-right: 10px;
    }

    .select_tab_box_wrap {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    .select_tab_box_wrap label {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

    .select_tab_box_wrap label input {
        width: 20px;
        height: 20px;
    }

    .applicant_chk .sign_form.custom_scroll {
        min-height: 150px;
    }
</style>
